import { render, staticRenderFns } from "./ApprovalWorkflow.vue?vue&type=template&id=6649bb5e"
import script from "./ApprovalWorkflow.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports